import { render, staticRenderFns } from "./Countdetails.vue?vue&type=template&id=03f81b98&scoped=true"
import script from "./Countdetails.vue?vue&type=script&lang=js"
export * from "./Countdetails.vue?vue&type=script&lang=js"
import style0 from "./Countdetails.vue?vue&type=style&index=0&id=03f81b98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f81b98",
  null
  
)

export default component.exports